import Vue from 'vue'
import Vuex from 'vuex'
import * as bankingInstitutions from '@/services/banking-institutions'
import utilities from '@/services/utilities'

Vue.use(Vuex)

export default {
	namespaced: true,
	state: {
		spinnerLoader: false,
		spinnerLoaderLabel: '',
		bankingInstitutionsList: [],
	},
	mutations: {
		SET_STATE(state, payload) {
			Object.assign(state, {
				...payload,
			})
		},
	},
	actions: {
		GET({ commit }) {
			commit('SET_STATE', {
				spinnerLoader: true,
			})
			bankingInstitutions
				.get()
				.then((response) => {
					commit('SET_STATE', {
						bankingInstitutionsList: _.cloneDeep(response.data),
					})
				})
				.catch((error) => {
					Vue.prototype.$notification.error({
						message: 'Institucions Bancarias',
						description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar el registro'),
					})
					commit('SET_STATE', {
						bankingInstitutionsList: [],
					})
				})
				.finally(() => {
					commit('SET_STATE', {
						spinnerLoader: false,
					})
				})
		},
		CREATE({ commit, dispatch, rootState }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Actualizando información',
			})
			return new Promise((resolve, reject) => {
				bankingInstitutions
					.create(payload)
					.then((response) => {
						Vue.prototype.$notification.success({
							message: 'Institucions Bancarias',
							description: response.message,
						})
						dispatch('GET')
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Institucions Bancarias',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al generar el registro'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		DISABLE({ commit, dispatch, rootState }, id) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Actualizando información',
			})
			bankingInstitutions
				.disable(id)
				.then((response) => {
					Vue.prototype.$notification.success({
						message: 'Institucions Bancarias',
						description: response.message,
					})
					dispatch('GET')
				})
				.catch((error) => {
					Vue.prototype.$notification.error({
						message: 'Institucions Bancarias',
						description: utilities.objectValidate(error, 'response.data.message', 'Error al deshabilitar el registro'),
					})
				})
				.finally(() => {
					commit('SET_STATE', {
						spinnerLoader: false,
					})
				})
		},
		ENABLE({ commit, dispatch, rootState }, id) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Actualizando información',
			})
			bankingInstitutions
				.enable(id)
				.then((response) => {
					Vue.prototype.$notification.success({
						message: 'Institucions Bancarias',
						description: response.message,
					})
					dispatch('GET')
				})
				.catch((error) => {
					Vue.prototype.$notification.error({
						message: 'Institucions Bancarias',
						description: utilities.objectValidate(error, 'response.data.message', 'Error al habilitar el registro'),
					})
				})
				.finally(() => {
					commit('SET_STATE', {
						spinnerLoader: false,
					})
				})
		},
		UPDATE({ commit, dispatch, rootState }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Actualizando información',
			})

			return new Promise((resolve, reject) => {
				bankingInstitutions
					.update(payload)
					.then((response) => {
						Vue.prototype.$notification.success({
							message: 'Institucions Bancarias',
							description: response.message,
						})
						dispatch('GET')
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Institucions Bancarias',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al actualizar el registro'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
	},
	getters: {
		bankingInstitutionsList: (state) => state.bankingInstitutionsList,
	},
}
